import { createI18n } from 'vue-i18n'
import zh_cn from '@/languages/zh-cn'
import en from '@/languages/en'
import fr from '@/languages/fr'
import de from '@/languages/de'
import ja from '@/languages/ja'
import ko from '@/languages/ko'

const i18n = createI18n({
  legacy: false, // 让 setup 函数可以通过 t 访问
  globalInjection: true, // 让 template 可以像 vue2 那样使用 $t 来访问
  locale: localStorage.getItem('language') ?? 'zh-cn',
  fallbackLocale: 'zh-cn',
  missing: (locale, key) => {
    console.warn(`缺失翻译: ${key}`);
    //console.log(locale, key);
    //if (key.endsWith('.'))
      return key;
    // else
    //   return key.substring(key.lastIndexOf('.') + 1);
  },
  messages: {
    'zh-cn': zh_cn,
    'en': en,
    'fr': fr,
    'de': de, 
    'ja': ja, 
    'ko': ko 
  }
})

const tc = (key)=>{
  return i18n.global.t(key);
}

export {i18n,tc} 